import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdPhone, MdEmail, MdLocationOn, MdAccessTime } from "react-icons/md";

export default function ContactUs() {
  const [contactDetails, setContactDetails] = useState(null);
  const adminId = sessionStorage.getItem('admin_auto_id');
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [themeIconColor, setThemeIconColor] = useState("");


  useEffect(() => {
  const storedStyle = sessionStorage.getItem("UIStyle");
  if (storedStyle) {
    const parsedStyle = JSON.parse(storedStyle);
    setWebFont(parsedStyle.web_font);
    setThemeColor(parsedStyle.web_theme_colour);
    setThemeIconColor(parsedStyle.web_theme_icon_color);
  }
}, []);
function lightenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + 255 * percent;
  let g = ((num >> 8) & 0x00ff) + 255 * percent;
  let b = (num & 0x0000ff) + 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

function darkenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

  useEffect(() => {
    const fetchContactDetails = async () => {
      try {
        const response = await axios.post(
          "https://gruzen.in/GrobizEcommerceAppBuilder/api/Show-Contact-Details",
          { admin_auto_id: adminId }
        );

        if (
          response.data.status === 1 &&
          response.data.allcontact_details.length > 0
        ) {
          setContactDetails(response.data.allcontact_details[0]);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      }
    };

    fetchContactDetails();
  }, []);

  if (!contactDetails) {
    return (
      <div className="p-6 text-center text-gray-500">
        Loading contact information...
      </div>
    );
  }

  return (
    <div className={`max-w-4xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-2xl border border-gray-200 ${webFont}`}>
      <h2 className="mb-6 text-2xl font-bold text-center text-gray-800">
        Contact Us
      </h2>
      <div className="grid grid-cols-1 gap-6 text-gray-700 sm:grid-cols-2">
        <div className="flex items-start gap-3">
          <MdPhone className="mt-1 text-2xl"
          style={{color:themeIconColor}} />
          <div>
            <p className="font-semibold">Phone</p>
            <p>{contactDetails.contact}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <MdEmail className="mt-1 text-2xl" style={{color:themeIconColor}}/>
          <div>
            <p className="font-semibold">Email</p>
            <p>{contactDetails.email}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <MdLocationOn className="mt-1 text-2xl" style={{color:themeIconColor}}/>
          <div>
            <p className="font-semibold">Address</p>
            <p>{contactDetails.address}</p>
          </div>
        </div>

        {/* <div className="flex items-start gap-3">
          <MdAccessTime className="mt-1 text-2xl" style={{color:themeIconColor}}/>
          <div>
            <p className="font-semibold">Office Hours</p>
            <p>{contactDetails.office_hrs || "Not specified"}</p>
          </div>
        </div> */}
      </div>
    </div>
  );
}
